import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import CreatorPage from "./pages/creator";
import AppRedirect from "./pages/app-redirect";
import Auth from "./pages/auth";
import AuthSuccess from "./pages/auth-success";
import CreatorSubscriptions from "./pages/creator-subscriptions";
import Success from "./pages/success";
import TestDeeplink from "./pages/test";
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/test",
    element: <TestDeeplink />,
  },
  {
    path: "/auth",
    element: <Auth />,
  },
  {
    path: "/:username",
    element: <CreatorPage />,
    loader: ({ params }) => {
      return { username: params.username };
    },
  },
  {
    path: "/:username/subscriptions",
    element: <CreatorSubscriptions />,
  },
  {
    path: "/success/:username/:planId",
    element: <Success />,
  },
  {
    path: "/app",
    element: <AppRedirect />,
  },
  {
    path: "/auth-success",
    element: <AuthSuccess />,
    loader: ({ params }) => {
      return { token: params.token };
    },
  },
  {
    path: "*",
    element: <div>404</div>,
  },
]);

export default router;
